module.exports = __webpack_public_path__ + "static/turtle-creek-house27-ee1b802aea92398d0cf285d891210f54.jpg";